import { useState } from 'react';

export default function Home() {
  const [formData, setFormData] = useState({
    nomPrenom: '',
    email: '',
    telephone: '',
    codePostal: '',
    puissance: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  
  // État pour le popup
  const [showPopup, setShowPopup] = useState(false);
  const [popupFormData, setPopupFormData] = useState({
    nomPrenom: '',
    email: '',
    telephone: '',
    codePostal: '',
    puissance: ''
  });
  const [isPopupSubmitting, setIsPopupSubmitting] = useState(false);
  const [popupSubmitMessage, setPopupSubmitMessage] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handlePopupInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setPopupFormData({
      ...popupFormData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d2rjjcijqms3b5jftu6g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody
      });

      if (response.ok) {
        setSubmitMessage('Votre demande a été envoyée avec succès ! Nous vous contacterons rapidement.');
        setFormData({
          nomPrenom: '',
          email: '',
          telephone: '',
          codePostal: '',
          puissance: ''
        });
      } else {
        setSubmitMessage('Une erreur est survenue. Veuillez réessayer.');
      }
    } catch (error) {
      setSubmitMessage('Une erreur est survenue. Veuillez réessayer.');
    }
    
    setIsSubmitting(false);
  };

  const handlePopupSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsPopupSubmitting(true);
    
    try {
      const formBody = new URLSearchParams();
      Object.entries(popupFormData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d2s786676ihulu0mpm80', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody
      });

      if (response.ok) {
        setPopupSubmitMessage('Votre demande a été envoyée avec succès ! Nous vous contacterons rapidement.');
        setPopupFormData({
          nomPrenom: '',
          email: '',
          telephone: '',
          codePostal: '',
          puissance: ''
        });
        setTimeout(() => {
          setShowPopup(false);
          setPopupSubmitMessage('');
        }, 2000);
      } else {
        setPopupSubmitMessage('Une erreur est survenue. Veuillez réessayer.');
      }
    } catch (error) {
      setPopupSubmitMessage('Une erreur est survenue. Veuillez réessayer.');
    }
    
    setIsPopupSubmitting(false);
  };

  const openPopup = () => {
    setShowPopup(true);
    setPopupSubmitMessage('');
  };

  const closePopup = () => {
    setShowPopup(false);
    setPopupSubmitMessage('');
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/9b48fcd6d2872550fe824c1ed95cf673.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-black/30"></div>
        <div className="relative z-10 w-full max-w-6xl mx-auto px-4 text-center text-white">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Produisez une énergie propre et durable !
          </h1>
          <p className="text-2xl md:text-3xl mb-8 text-blue-100">
            Avec Mon offre solaire, passez à l'autoconsommation solaire.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="#devis" 
              className="inline-block bg-emerald-600 hover:bg-emerald-700 text-white px-12 py-4 rounded-full text-xl font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              Obtenez une étude gratuite
            </a>
            <button 
              onClick={openPopup}
              className="inline-block bg-sky-600 hover:bg-sky-700 text-white px-12 py-4 rounded-full text-xl font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              Devis rapide
            </button>
          </div>
        </div>
      </section>

      {/* Solutions Section */}
      <section id="solutions" className="py-20 bg-emerald-50">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-emerald-800 mb-16">
            Nos solutions solaires accessibles
          </h2>
          <div className="grid md:grid-cols-2 gap-12 max-w-4xl mx-auto">
            {/* Pack 3 kWc */}
            <div className="bg-white p-8 rounded-2xl shadow-lg text-center">
              <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-sun-line text-3xl text-emerald-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-emerald-800 mb-4">Pack 3 kWc + Batterie</h3>
              <div className="text-4xl font-bold text-emerald-600 mb-6">7 990 €</div>
              <div className="flex justify-center space-x-4 mb-6">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center">
                  <i className="ri-leaf-line text-emerald-600"></i>
                </div>
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center">
                  <i className="ri-battery-charge-line text-emerald-600"></i>
                </div>
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center">
                  <i className="ri-home-eco-line text-emerald-600"></i>
                </div>
              </div>
              <p className="text-gray-600">Idéal pour les petites habitations et les premiers pas vers l'autonomie énergétique</p>
            </div>

            {/* Pack 6 kWc */}
            <div className="bg-white p-8 rounded-2xl shadow-lg text-center">
              <div className="w-20 h-20 bg-sky-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-sun-fill text-3xl text-sky-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-emerald-800 mb-4">Pack 6 kWc + Batterie</h3>
              <div className="text-4xl font-bold text-sky-600 mb-6">9 990 €</div>
              <div className="flex justify-center space-x-4 mb-6">
                <div className="w-12 h-12 bg-sky-100 rounded-full flex items-center justify-center">
                  <i className="ri-leaf-line text-sky-600"></i>
                </div>
                <div className="w-12 h-12 bg-sky-100 rounded-full flex items-center justify-center">
                  <i className="ri-battery-charge-line text-sky-600"></i>
                </div>
                <div className="w-12 h-12 bg-sky-100 rounded-full flex items-center justify-center">
                  <i className="ri-home-eco-line text-sky-600"></i>
                </div>
              </div>
              <p className="text-gray-600">Parfait pour les familles souhaitant une indépendance énergétique maximale</p>
            </div>
          </div>
        </div>
      </section>

      {/* Avantages Section */}
      <section id="avantages" className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-emerald-800 mb-16">
            Avantages écologiques et économiques
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-euro-circle-line text-2xl text-emerald-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-emerald-800 mb-3">Réduisez vos factures</h3>
              <p className="text-gray-600">Diminuez considérablement vos factures d'électricité grâce à l'autoconsommation</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-sky-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-earth-line text-2xl text-sky-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-emerald-800 mb-3">Transition énergétique</h3>
              <p className="text-gray-600">Contribuez activement à la protection de l'environnement et au développement durable</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-home-heart-line text-2xl text-emerald-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-emerald-800 mb-3">Valorisez votre logement</h3>
              <p className="text-gray-600">Augmentez la valeur de votre bien immobilier avec une installation durable</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-sky-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-2xl text-sky-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-emerald-800 mb-3">SAV réactif</h3>
              <p className="text-gray-600">Bénéficiez d'un service après-vente de qualité en France & DOM-TOM</p>
            </div>
          </div>
        </div>
      </section>

      {/* Formulaire de devis */}
      <section id="devis" className="py-20 bg-gradient-to-br from-emerald-50 to-sky-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-center text-emerald-800 mb-4">
              Votre maison peut devenir une source d'énergie !
            </h2>
            <p className="text-xl text-center text-gray-600 mb-12">
              Obtenez votre étude personnalisée gratuite en quelques clics
            </p>
            
            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <form id="devis-form" data-readdy-form onSubmit={handleSubmit} className="grid md:grid-cols-2 gap-6">
                <div className="md:col-span-2">
                  <label htmlFor="nomPrenom" className="block text-sm font-medium text-gray-700 mb-2">
                    Nom et Prénom *
                  </label>
                  <input
                    type="text"
                    id="nomPrenom"
                    name="nomPrenom"
                    value={formData.nomPrenom}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                    placeholder="Jean Dupont"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                    placeholder="votre@email.fr"
                  />
                </div>
                
                <div>
                  <label htmlFor="telephone" className="block text-sm font-medium text-gray-700 mb-2">
                    Téléphone *
                  </label>
                  <input
                    type="tel"
                    id="telephone"
                    name="telephone"
                    value={formData.telephone}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                    placeholder="06 12 34 56 78"
                  />
                </div>
                
                <div>
                  <label htmlFor="codePostal" className="block text-sm font-medium text-gray-700 mb-2">
                    Code postal *
                  </label>
                  <input
                    type="text"
                    id="codePostal"
                    name="codePostal"
                    value={formData.codePostal}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                    placeholder="75001"
                  />
                </div>
                
                <div className="md:col-span-2">
                  <label htmlFor="puissance" className="block text-sm font-medium text-gray-700 mb-2">
                    Puissance souhaitée *
                  </label>
                  <div className="relative">
                    <select
                      id="puissance"
                      name="puissance"
                      value={formData.puissance}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm appearance-none bg-white cursor-pointer"
                    >
                      <option value="">Sélectionnez une option</option>
                      <option value="3kw-batterie">3 kW + batterie</option>
                      <option value="6kw-batterie">6 kW + batterie</option>
                      <option value="9kw-batterie">9 kW + batterie</option>
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                      <i className="ri-arrow-down-s-line text-gray-400"></i>
                    </div>
                  </div>
                </div>
                
                <div className="md:col-span-2">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-emerald-600 hover:bg-emerald-700 disabled:bg-emerald-400 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {isSubmitting ? 'Envoi en cours...' : 'Je veux mon étude gratuite'}
                  </button>
                </div>

                {submitMessage && (
                  <div className="md:col-span-2">
                    <div className={`p-4 rounded-lg ${submitMessage.includes('succès') ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                      {submitMessage}
                    </div>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Témoignages */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-emerald-800 mb-16">
            Ils nous font confiance
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-emerald-50 p-6 rounded-2xl">
              <div className="flex items-center mb-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=Happy%20middle-aged%20French%20couple%20with%20solar%20panels%20in%20background%2C%20smiling%20family%20portrait%2C%20eco-friendly%20lifestyle%2C%20natural%20outdoor%20setting%20with%20green%20environment%2C%20professional%20photography%2C%20warm%20lighting%2C%20genuine%20expressions%20of%20satisfaction&width=80&height=80&seq=temoignage-1&orientation=squarish"
                  alt="Famille Martin"
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-semibold text-emerald-800">Famille Martin</h4>
                  <p className="text-sm text-gray-600">Bordeaux</p>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "Grâce à AIRPURE, nous avons réduit notre facture d'électricité de 70% ! Un investissement écologique qui nous fait économiser chaque mois."
              </p>
              <div className="flex mt-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
            </div>

            <div className="bg-sky-50 p-6 rounded-2xl">
              <div className="flex items-center mb-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=Satisfied%20French%20woman%20in%20her%20forties%20standing%20next%20to%20eco-friendly%20house%20with%20solar%20installation%2C%20confident%20smile%2C%20environmental%20consciousness%2C%20green%20technology%20adoption%2C%20professional%20portrait%20with%20natural%20background&width=80&height=80&seq=temoignage-2&orientation=squarish"
                  alt="Sophie Durand"
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-semibold text-emerald-800">Sophie Durand</h4>
                  <p className="text-sm text-gray-600">Lyon</p>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "Installation rapide et équipe professionnelle. Je recommande vivement pour tous ceux qui veulent agir pour la planète."
              </p>
              <div className="flex mt-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
            </div>

            <div className="bg-emerald-50 p-6 rounded-2xl">
              <div className="flex items-center mb-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=Happy%20French%20family%20with%20children%20in%20front%20of%20modern%20house%20with%20solar%20panels%2C%20eco-conscious%20parents%20teaching%20sustainability%20to%20kids%2C%20green%20energy%20lifestyle%2C%20bright%20sunny%20day%2C%20environmental%20awareness&width=80&height=80&seq=temoignage-3&orientation=squarish"
                  alt="Famille Leroy"
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-semibold text-emerald-800">Famille Leroy</h4>
                  <p className="text-sm text-gray-600">Nantes</p>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "Nos enfants sont fiers de vivre dans une maison qui produit sa propre énergie verte. Un choix d'avenir !"
              </p>
              <div className="flex mt-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Zone d'intervention */}
      <section className="py-20 bg-gradient-to-r from-emerald-600 to-sky-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-8">Nous intervenons dans toute la France</h2>
          <p className="text-xl mb-8">France métropolitaine</p>
          <div className="flex justify-center items-center">
            <i className="ri-map-pin-line text-6xl mr-4"></i>
            <div className="text-left">
              <p className="text-lg">Service national</p>
              <p className="text-2xl font-semibold">Partout où vous êtes</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="contact" className="bg-emerald-900 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="text-2xl font-bold mb-4" style={{ fontFamily: 'Pacifico, serif' }}>
                Mon offre solaire
              </div>
              <p className="text-emerald-200 mb-6">
                Votre partenaire pour une énergie propre et durable
              </p>
              <div className="flex space-x-4">
                <a href="#" className="w-10 h-10 bg-emerald-700 rounded-full flex items-center justify-center hover:bg-emerald-600 cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-emerald-700 rounded-full flex items-center justify-center hover:bg-emerald-600 cursor-pointer">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-emerald-700 rounded-full flex items-center justify-center hover:bg-emerald-600 cursor-pointer">
                  <i className="ri-linkedin-fill"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Contact</h4>
              <div className="space-y-3 text-emerald-200">
                <div className="flex items-center">
                  <i className="ri-mail-line mr-3"></i>
                  <span>contact@mon-offre-solaire.fr</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-phone-line mr-3"></i>
                  <span>01 72 68 33 28</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-map-pin-line mr-3 mt-1"></i>
                  <span>Toute la France<br />France & DOM-TOM</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Nos Solutions</h4>
              <ul className="space-y-2 text-emerald-200">
                <li><a href="#solutions" className="hover:text-white cursor-pointer">Pack 3 kWc</a></li>
                <li><a href="#solutions" className="hover:text-white cursor-pointer">Pack 6 kWc</a></li>
                <li><a href="#devis" className="hover:text-white cursor-pointer">Étude gratuite</a></li>
                <li><a href="#avantages" className="hover:text-white cursor-pointer">Nos avantages</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Informations</h4>
              <ul className="space-y-2 text-emerald-200">
                <li><a href="#" className="hover:text-white cursor-pointer">Mentions légales</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Politique de confidentialité</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">CGV</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">À propos</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-emerald-700 mt-12 pt-8">
            <div className="text-center text-emerald-200">
              <p className="mb-4">
                <strong>Ce site n'est pas affilié à Facebook ni à Meta Platforms Inc. Les informations saisies sont uniquement destinées à Mon offre solaire.</strong>
              </p>
              <p>&copy; 2024 Mon offre solaire. Tous droits réservés.</p>
            </div>
          </div>
        </div>
      </footer>

      {/* Popup */}
      {showPopup && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-emerald-800">Devis rapide</h3>
                <button 
                  onClick={closePopup}
                  className="w-8 h-8 flex items-center justify-center text-gray-500 hover:text-gray-700 cursor-pointer"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>
              
              <form id="popup-devis-form" data-readdy-form onSubmit={handlePopupSubmit} className="space-y-4">
                <div>
                  <label htmlFor="popup-nomPrenom" className="block text-sm font-medium text-gray-700 mb-2">
                    Nom et Prénom *
                  </label>
                  <input
                    type="text"
                    id="popup-nomPrenom"
                    name="nomPrenom"
                    value={popupFormData.nomPrenom}
                    onChange={handlePopupInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                    placeholder="Jean Dupont"
                  />
                </div>
                
                <div>
                  <label htmlFor="popup-email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="popup-email"
                    name="email"
                    value={popupFormData.email}
                    onChange={handlePopupInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                    placeholder="votre@email.fr"
                  />
                </div>
                
                <div>
                  <label htmlFor="popup-telephone" className="block text-sm font-medium text-gray-700 mb-2">
                    Téléphone *
                  </label>
                  <input
                    type="tel"
                    id="popup-telephone"
                    name="telephone"
                    value={popupFormData.telephone}
                    onChange={handlePopupInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                    placeholder="06 12 34 56 78"
                  />
                </div>
                
                <div>
                  <label htmlFor="popup-codePostal" className="block text-sm font-medium text-gray-700 mb-2">
                    Code postal *
                  </label>
                  <input
                    type="text"
                    id="popup-codePostal"
                    name="codePostal"
                    value={popupFormData.codePostal}
                    onChange={handlePopupInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm"
                    placeholder="75001"
                  />
                </div>
                
                <div>
                  <label htmlFor="popup-puissance" className="block text-sm font-medium text-gray-700 mb-2">
                    Puissance souhaitée *
                  </label>
                  <div className="relative">
                    <select
                      id="popup-puissance"
                      name="puissance"
                      value={popupFormData.puissance}
                      onChange={handlePopupInputChange}
                      required
                      className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-sm appearance-none bg-white cursor-pointer"
                    >
                      <option value="">Sélectionnez une option</option>
                      <option value="3kw-batterie">3 kW + batterie</option>
                      <option value="6kw-batterie">6 kW + batterie</option>
                      <option value="9kw-batterie">9 kW + batterie</option>
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                      <i className="ri-arrow-down-s-line text-gray-400"></i>
                    </div>
                  </div>
                </div>
                
                <div className="pt-4">
                  <button
                    type="submit"
                    disabled={isPopupSubmitting}
                    className="w-full bg-emerald-600 hover:bg-emerald-700 disabled:bg-emerald-400 text-white px-8 py-3 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {isPopupSubmitting ? 'Envoi en cours...' : 'Envoyer ma demande'}
                  </button>
                </div>

                {popupSubmitMessage && (
                  <div className="mt-4">
                    <div className={`p-4 rounded-lg ${popupSubmitMessage.includes('succès') ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                      {popupSubmitMessage}
                    </div>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}